import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { Project, Site } from '../../utils/types';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface PanelsState {
  //
  // note: the focused divs are only used if the selected item is currently
  // hidden by the filter box. the focused divs don't do anything if the selected
  // item is currently visible.
  selectedSessionTypeDiv: { divID: number };
  //
}

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: PanelsState = {
  selectedSessionTypeDiv: { divID: 0 },
};

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const panelsSlice = createSlice({
  name: 'panels',
  initialState: initialState,
  reducers: {
    //
    setSelectedSessionTypeDiv: (
      state: PanelsState,
      action: PayloadAction<{ divID: number }>,
    ) => {
      state.selectedSessionTypeDiv = action.payload;
    },
    //
  },
});

// expose the interface.
export const { setSelectedSessionTypeDiv } = panelsSlice.actions;

export default panelsSlice.reducer;
